export default "/images/eastern-blue-check.svg";